import React from 'react'
import PropTypes from 'prop-types'
import { FormGroup, InputGroup, FormControl } from 'react-bootstrap'
import cx from 'classnames'
import { Check } from 'styled-icons/fa-solid/Check'

class PopoverInput extends React.Component {
  constructor(...args) {
    super(...args)
    this.state = {
      value: this.props.value,
    }
  }

  setValue = e => this.setState({ [e.target.id]: e.target.value})
  onComplete = () => this.state.value && this.props.onChange(this.state.value)
  onKeyEnter = e => e.key === 'Enter' && this.props.onChange(this.state.value)
  close = () => this.setState({ close: 'fade' })

  render() {
    const { arrowOffsetLeft, arrowOffsetTop, placement, title, placeholder, className } = this.props
    const containerClass = cx('popover', placement, className)

    return (
      <div id='popover-input' role='tooltip' className={containerClass} style={{ display: 'block', ...this.props.style }}>
        <div className='arrow' style={{left: arrowOffsetLeft, top: arrowOffsetTop}} />
        <h3 className='popover-title'>{title}</h3>
        <div className='popover-content'>
          <FormGroup controlId='value' >
            <InputGroup bsSize='sm'>
              <FormControl value={this.state.value} type='text' onChange={this.setValue} onKeyUp={this.onKeyEnter} placeholder={placeholder || ''} />
              <InputGroup.Addon onClick={this.onComplete}><Check color='green' size={14}/></InputGroup.Addon>
            </InputGroup>
          </FormGroup>
        </div>
      </div>
    )
  }
}


PopoverInput.defaultProps = {
  title: 'Type',
  value: '',
  placeholder: '',
  onChange: () => {}
}

PopoverInput.propTypes = {
  title: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func
}

export default PopoverInput



// WEBPACK FOOTER //
// ./src/components/widgets/PopoverInput.js